export default __webpack_public_path__ + "static/media/create-account-office-dark.080280cb.jpeg";